import React from 'react'
import MaskDropdown from '../../components/MaskDropdown.jsx'
import './header.css'
import { Link } from 'react-router-dom'

function Header() {
	return (
		<div id='headerContainer'>
			<div id='titleContainer'>
				<h1 id='title'>
					Suche nach Werken, Künstlern und Besitzern
					<br /> oder nach Kombinationen aus diesen Begriffen
				</h1>
			</div>

			<div id='navigationContainer'>
				<div className='menu_option'>
					<Link to='/' className='defaultButton'>
						Home
					</Link>
				</div>

				<div className='menu_option'>
					<MaskDropdown
						borderColor='darkviolet'
						backgroundColor='#d164ff'
						trigger={
							<a className='defaultButton moreOptionsIcon'>Weitere Masken</a>
						}
						style={{ marginTop: '-15px' }}
						hideOption={3}
					/>
				</div>
			</div>
		</div>
	)
}

export default Header
